module.exports = __webpack_public_path__ + "static/img/p5_2.c112993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/p5/p5_2.png
// module id = 663
// module chunks = 0